"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateTaskDto = exports.CreateTaskDocumentDto = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const swagger_1 = require("@nestjs/swagger");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class CreateTaskDocumentDto {
}
exports.CreateTaskDocumentDto = CreateTaskDocumentDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document ID",
        example: 1,
    }),
    (0, class_validator_1.IsInt)({ message: "Document ID must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Document ID is required." }),
    (0, class_validator_1.Min)(1, {
        message: "Document ID must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateTaskDocumentDto.prototype, "documentId", void 0);
class CreateTaskDto {
}
exports.CreateTaskDto = CreateTaskDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Task name",
        example: "test task",
    }),
    (0, class_validator_1.IsString)({ message: "Task name must be a string." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Task name is required." }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    tslib_1.__metadata("design:type", String)
], CreateTaskDto.prototype, "taskName", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsInt)({ message: "Activity id must be a number." }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Min)(1, {
        message: "Activity id must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateTaskDto.prototype, "activityId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsInt)({ message: "Company id must be a number." }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Min)(1, {
        message: "Company id must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateTaskDto.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsInt)({ message: "Opportunity id must be a number." }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Min)(1, {
        message: "Opportunity id must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateTaskDto.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Assignee ID",
        example: 1,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Assignee id must be a number." }),
    (0, class_validator_1.Min)(1, {
        message: "Assignee id must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateTaskDto.prototype, "assigneeId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Task Date",
        type: String,
        example: "2025-06-20",
    }),
    (0, class_validator_1.IsString)({ message: "Task date must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    (0, class_validator_1.Matches)(/^\d{4}-\d{2}-\d{2}$/, {
        message: "Task date must be in the format YYYY-MM-DD.",
    }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const date = new Date(value);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (date < today) {
            throw new common_1.BadRequestException("The task date cannot be past date. Please provide a valid date.");
        }
        return value;
    }),
    tslib_1.__metadata("design:type", String)
], CreateTaskDto.prototype, "dueDate", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Task status ID must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateTaskDto.prototype, "taskStatusLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Task type ID must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateTaskDto.prototype, "taskTypeLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Task close must be a string." }),
    tslib_1.__metadata("design:type", String)
], CreateTaskDto.prototype, "taskClose", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Task is editable must be a string." }),
    tslib_1.__metadata("design:type", String)
], CreateTaskDto.prototype, "taskIsEditable", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Priority ID", example: 53 }),
    (0, class_validator_1.IsInt)({ message: "Priority ID must be a number." }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Min)(1, {
        message: "Priority ID must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateTaskDto.prototype, "priorityLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Description",
        type: String,
        example: "Task description",
    }),
    (0, class_validator_1.IsString)({ message: "Description must be a string." }),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => value ? value.trim() : value),
    tslib_1.__metadata("design:type", String)
], CreateTaskDto.prototype, "description", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Task documents",
        type: [CreateTaskDocumentDto],
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)({ message: "Task documents must be an array." }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => CreateTaskDocumentDto),
    tslib_1.__metadata("design:type", Array)
], CreateTaskDto.prototype, "documents", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateTaskDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateTaskDto.prototype, "updatedBy", void 0);
